import styled from "styled-components";
import colors from "../../constants/color";
import materialUI from "../../material-UI";

export const Modal = styled(materialUI.Dialog)`
  .MuiDialog-paper {
    overflow: unset;
  }
  .MuiDialog-paperWidthSm {
    max-width: 1000px;
  }
  &.shake-true {
    .MuiDialog-paper {
      animation: shake 0.8s;
      animation-iteration-count: infinite;
    }

    @keyframes shake {
      0% {
        transform: translate(1px, 1px) rotate(0deg);
      }
      10% {
        transform: translate(-1px, -2px) rotate(-1deg);
      }
      20% {
        transform: translate(-3px, 0px) rotate(1deg);
      }
      30% {
        transform: translate(3px, 2px) rotate(0deg);
      }
      40% {
        transform: translate(1px, -1px) rotate(1deg);
      }
      50% {
        transform: translate(-1px, 2px) rotate(-1deg);
      }
      60% {
        transform: translate(-3px, 1px) rotate(0deg);
      }
      70% {
        transform: translate(3px, 1px) rotate(-1deg);
      }
      80% {
        transform: translate(-1px, -1px) rotate(1deg);
      }
      90% {
        transform: translate(1px, 2px) rotate(0deg);
      }
      100% {
        transform: translate(1px, -2px) rotate(-1deg);
      }
    }
  }
`;

export const DialogHeader = styled(materialUI.DialogTitle)`
  padding: 24px 24px 0 24px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
`;

export const TitleHeader = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: ${colors.gray900};
  font-family: Inter-Medium;

  svg {
    margin-right: 20px;
  }
`;

export const IconButton = styled(materialUI.IconButton)`
  cursor: pointer;
  color: ${colors.gray500};
`;

export const ContainerModal = styled(materialUI.DialogContent)`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 24px;
  gap: 8px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 12px;
  border: 1px solid ${colors.gray300};
  border-radius: 8px;
  font-family: Inter;
  font-size: 14px;
  resize: vertical;
  outline: none;

  &:focus {
    border-color: ${colors.primary};
  }

  &::placeholder {
    color: ${colors.gray100};
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.LigthGrey};
  }
`;

export const CharCount = styled.span`
  font-family: Inter;
  font-size: 13px;
  color: ${colors.grey1};
  text-align: right;
  margin-top: 4px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
  justify-content: flex-end;
`;

export const CancelButton = styled.button`
  padding: 10px 20px;
  border: 1px solid ${colors.gray300};
  border-radius: 8px;
  background-color: white;
  color: ${colors.Black};
  font-family: Inter-Medium;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: ${colors.gray100};
  }
`;

export const ConfirmButton = styled.button`
  padding: 10px 20px;
  border: 1px solid ${colors.primary};
  border-radius: 8px;
  background-color: ${colors.primary};
  color: white;
  font-family: Inter-Medium;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: ${colors.Primaryv1};
  }

  &:disabled {
    background-color: ${colors.gray300};
    border-color: ${colors.gray300};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
